import * as Types from '@/types/schema';

import gql from 'graphql-tag';
import { ActionPlanResolvedOwnerFragmentDoc } from '../../../../../graphql/fragments/generated/ActionPlanResolvedOwner';
import { UserFragmentDoc } from '../../../../../../../graphql/fragments/generated/User';
import { ActionPlanEditorFocusAreaEntitiesFragmentDoc } from '../../../../ActionPlanEditor/graphql/queries/generated/actionPlanEditorDetails';
import * as Urql from '@/utils/urql';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type ActionPlanDetailsUserSurveyFragment = { id: string, name: string, cyclesDateRange?: Array<{ startDate: string, endDate: string, cycleNumber: number }> | null };


export type ActionPlanDetailsUserSurveyFragmentVariables = Types.Exact<{ [key: string]: never; }>;

export type ActionPlanDetailsFragment = { id: string, name: string, status: Types.ActionPlanStatusEnum, dueDate?: string | null, cycleId?: string | null, description?: string | null, parentEntities: Array<string>, owner: { ownerId: string }, actionableTasks?: Array<{ id: string }> | null, parentSurvey?: { id: string, name: string, cyclesDateRange?: Array<{ startDate: string, endDate: string, cycleNumber: number }> | null } | null, parentPerformanceReview?: { id: string, title: string } | null, resolvedOwner?: { __typename: 'DepartmentType' } | { __typename: 'UserType', id: string, name?: string | null, uniqueId: string, emailId?: string | null, profilePicture?: string | null, orgRole?: { id: string, name: string } | null } | { __typename: 'WorkspaceType' } | null, focusAreaEntities?: Array<{ id: string, flagOn: Types.FlagOnEntityEnum, flaggedQuestion?: { id: string, questionText?: string | null, questionType: Types.QuestionTypeEnum } | null, flaggedTheme?: { id: string, name: string } | null, flaggedMindset?: { id: string, name: string } | null, flaggedSkill?: { id: string, name: string } | null, flaggedSkillGroup?: { _id: string, name: string } | null, performanceReviewMetadata?: Array<{ scoreConfig?: { score: number } | null }> | null, filterGroup?: { operator: Types.FilterOperatorEnum, filters: Array<{ operator: Types.FilterOperatorEnum, property?: string | null, value?: string | null, filters: Array<{ operator: Types.FilterOperatorEnum, property: string, value: string }> }> } | null, surveyResponseMetadata?: Array<{ cycleId?: number | null, responseCount?: number | null, participationCount?: number | null, scoreConfig?: { score: number, passiveCount: number, promotersCount: number, detractorsCount: number } | null }> | null }> | null };


export type ActionPlanDetailsFragmentVariables = Types.Exact<{ [key: string]: never; }>;

export type ActionPlanDetailsQueryVariables = Types.Exact<{
  filters?: Types.InputMaybe<Types.ActionPlanFilters>;
}>;


export type ActionPlanDetailsQuery = { actionPlan?: { id: string, name: string, status: Types.ActionPlanStatusEnum, dueDate?: string | null, cycleId?: string | null, description?: string | null, parentEntities: Array<string>, owner: { ownerId: string }, actionableTasks?: Array<{ id: string }> | null, parentSurvey?: { id: string, name: string, cyclesDateRange?: Array<{ startDate: string, endDate: string, cycleNumber: number }> | null } | null, parentPerformanceReview?: { id: string, title: string } | null, resolvedOwner?: { __typename: 'DepartmentType' } | { __typename: 'UserType', id: string, name?: string | null, uniqueId: string, emailId?: string | null, profilePicture?: string | null, orgRole?: { id: string, name: string } | null } | { __typename: 'WorkspaceType' } | null, focusAreaEntities?: Array<{ id: string, flagOn: Types.FlagOnEntityEnum, flaggedQuestion?: { id: string, questionText?: string | null, questionType: Types.QuestionTypeEnum } | null, flaggedTheme?: { id: string, name: string } | null, flaggedMindset?: { id: string, name: string } | null, flaggedSkill?: { id: string, name: string } | null, flaggedSkillGroup?: { _id: string, name: string } | null, performanceReviewMetadata?: Array<{ scoreConfig?: { score: number } | null }> | null, filterGroup?: { operator: Types.FilterOperatorEnum, filters: Array<{ operator: Types.FilterOperatorEnum, property?: string | null, value?: string | null, filters: Array<{ operator: Types.FilterOperatorEnum, property: string, value: string }> }> } | null, surveyResponseMetadata?: Array<{ cycleId?: number | null, responseCount?: number | null, participationCount?: number | null, scoreConfig?: { score: number, passiveCount: number, promotersCount: number, detractorsCount: number } | null }> | null }> | null } | null };

export const ActionPlanDetailsUserSurveyFragmentDoc = /*#__PURE__*/ gql`
    fragment ActionPlanDetailsUserSurvey on UserSurveyType {
  id
  name
  cyclesDateRange {
    startDate
    endDate
    cycleNumber
  }
}
    `;
export const ActionPlanDetailsFragmentDoc = /*#__PURE__*/ gql`
    fragment ActionPlanDetails on ActionPlanType {
  id
  name
  status
  dueDate
  cycleId
  description
  parentEntities
  owner {
    ownerId
  }
  actionableTasks {
    id
  }
  parentSurvey {
    ...ActionPlanDetailsUserSurvey
  }
  parentPerformanceReview {
    id
    title
  }
  resolvedOwner {
    ...ActionPlanResolvedOwner
  }
  focusAreaEntities {
    ...ActionPlanEditorFocusAreaEntities
  }
}
    `;
export const ActionPlanDetailsDocument = /*#__PURE__*/ gql`
    query actionPlanDetails($filters: ActionPlanFilters) {
  actionPlan(filters: $filters) {
    ...ActionPlanDetails
  }
}
    ${ActionPlanDetailsFragmentDoc}
${ActionPlanDetailsUserSurveyFragmentDoc}
${ActionPlanResolvedOwnerFragmentDoc}
${UserFragmentDoc}
${ActionPlanEditorFocusAreaEntitiesFragmentDoc}`;

export function useActionPlanDetailsQuery(options?: Omit<Urql.UseQueryArgs<ActionPlanDetailsQueryVariables>, 'query'>) {
  return Urql.useQuery<ActionPlanDetailsQuery, ActionPlanDetailsQueryVariables>({ query: ActionPlanDetailsDocument, ...options });
};